export default __webpack_public_path__ + "static/media/error_circle.8caa15c7.svg";